import React, { useRef } from "react";
import TextInput from "_c/form/TextInput";
import Label from "_c/form/Label";
import Sect from "_c/form/Sect";
import { Button } from "_c/button";
import ButtonGroup from "_c/form/ButtonGroup";
import { StyledForm } from "./styled";
import { useTranslation } from "react-i18next";
import { useMut } from "@/hooks/useMut";
import type { tSendInternalMessageModalProps } from "./types";
import { useDispatch } from "react-redux";
import { Effects as MessengerEffects } from "@/store/messenger/effects";

const InternalMessageForm = (props: tSendInternalMessageModalProps) => {
  const dispatch = useDispatch();
  const { t, ready } = useTranslation(["common", "errors"], {
    useSuspense: false,
  });
  const sendMessageMut = useMut(
    async () => {
      const msg = inputRef.current!.value;
      await dispatch(
        MessengerEffects.createMessageOutsideMessenger(props.receiverId, msg),
      );
    },
    {
      t,
      notifyOnError: true,
      onSuccess() {
        props.onClose();
      },
    },
  );
  const inputRef = useRef<Maybe<HTMLTextAreaElement>>(null);
  if (!ready) return null;
  return (
    <StyledForm
      style={{ textAlign: "left" }}
      onSubmit={(e) => {
        e.preventDefault();
        sendMessageMut.mutate();
      }}
    >
      <Sect>
        <Label htmlFor="message-input">{t("common:message")}</Label>
        <TextInput
          autoFocus
          rows={4}
          as="textarea"
          id="message-input"
          ref={inputRef}
          required
        />
      </Sect>
      <ButtonGroup>
        <Button
          small
          greenish
          type="submit"
          disabled={sendMessageMut.isLoading}
        >
          {t("common:send")}
        </Button>
        <Button onClick={props.onClose} small negative type="button">
          {t("common:cancel")}
        </Button>
      </ButtonGroup>
    </StyledForm>
  );
};

export default InternalMessageForm;
